const screens = ['clients-list', 'free-leads-list'];
const key = (userId, screen) => `sales-crm:filters:${userId}:${screen}`;
const popupMarker = 'sales-crm-filter-popup';

export const readFilterSession = (userId, screen) => {
  if (!userId) return null;
  try {
    // window.open copies sessionStorage from its opener. A new tab starts from the server filter.
    if (window.opener && window.name !== popupMarker) {
      clearSalesCrmFilterSessions(userId);
      window.name = popupMarker;
    }
    const value = sessionStorage.getItem(key(userId, screen));
    return value === null ? null : JSON.parse(value);
  } catch {
    return null;
  }
};

export const writeFilterSession = (userId, screen, filters) => {
  if (!userId) return;
  try { sessionStorage.setItem(key(userId, screen), JSON.stringify(filters)); } catch { /* Browsing still works without storage. */ }
};

export const clearFilterSession = (userId, screen) => {
  if (!userId) return;
  try { sessionStorage.removeItem(key(userId, screen)); } catch { /* Browsing still works without storage. */ }
};

export const clearSalesCrmFilterSessions = (userId) => {
  screens.forEach((screen) => clearFilterSession(userId, screen));
};
